export const orderStatus = {
  free: 'free',
  reserved: 'reserved',
  delivered: 'delivered',
  expired: 'expired',
  removed: 'removed',
  inactive: 'disabled'
};
